import { API_endpoints } from "./config";

export const getAllParent = async () => {
    try {
        const response = await fetch(API_endpoints.getAllParent, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({}),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von parent Daten.");
        }
        return await response.json();
        
    } catch (error) {
        console.error("Fehler beim Laden parent von Daten:", error);
    }
};